import React, { useState } from "react";
import { getConsistentColor } from "../../../utils";

type AvatarProps = {
  text?: string;
  bgColor?: string;
  size?: number;
  fontsize?: number;
  baseURL?: string;
  logo?: string;
};

export const Avatar: React.FC<AvatarProps> = ({
  text,
  bgColor,
  baseURL,
  logo,
  size = 35,
  fontsize = 15,
}) => {
  const [imgError, setImgError] = useState(false);

  if (!text) return null;

  const logoUrl = baseURL && logo ? `${baseURL}/${logo}.jpg` : null;

  // Set a default background color if none is provided
  if (!bgColor && text) {
    bgColor = getConsistentColor(text);
  }

  const showText = imgError || !logoUrl;

  return (
    <div
      className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold overflow-hidden"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor: bgColor,
        fontSize: `${fontsize}px`,
        minWidth: `${size}px`,
      }}
    >
      {!showText && (
        <img
          src={logoUrl!}
          alt="Avatar"
          onError={() => setImgError(true)}
          className="w-100 h-100 object-fit-contain rounded-circle"
        />
      )}
      {showText && text.charAt(0).toUpperCase()}
    </div>
  );
};

export default Avatar;
